/**
 * Global checkout context (e.g. payment webview). Pending cancel is handled by usePendingSubscriptions().cancelPending.
 */
import React from 'react';

export type NewCheckoutData = any;
export type PendingCheckoutData = any;

export interface CheckoutContextValue {
  [key: string]: unknown;
}

export const CheckoutContext = ({ children }: { children: React.ReactNode }) => React.createElement(React.Fragment, null, children);

let context_value: CheckoutContextValue | null = null;
const listeners: Array<(ctx: CheckoutContextValue | null) => void> = [];

export const CheckoutGlobalService = {
  getContext(): CheckoutContextValue | null {
    return context_value;
  },
  setContext(ctx: CheckoutContextValue | null): void {
    context_value = ctx;
    listeners.forEach(cb => cb(context_value));
  },
  subscribeToContext(cb: (ctx: CheckoutContextValue | null) => void): () => void {
    listeners.push(cb);
    return () => {
      const i = listeners.indexOf(cb);
      if (i >= 0) {
        listeners.splice(i, 1);
      }
    };
  },
};
